import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import './FormItem.scss';
export const FormItemContext = createContext({
    id: undefined,
    descriptionId: undefined,
    isInvalid: false,
});
export const FormItem = ({ id, label, hint, help, isRequired, requiredLabel = 'Povinná položka', helpLabel = 'Zobrazit nápovědu', errorMessage, characterCount, children, }) => {
    const [showHelp, setShowHelp] = useState(false);
    const showDescription = hint || errorMessage || help;
    const context = useMemo(() => ({
        id,
        descriptionId: showDescription && id ? `${id}-desc` : undefined,
        isInvalid: !!errorMessage,
    }), [id, hint, errorMessage]);
    const handleLabelClick = () => {
        setShowHelp(!showHelp);
    };
    const labelTooltipArray = [];
    help && labelTooltipArray.push(helpLabel);
    isRequired && labelTooltipArray.push(requiredLabel);
    return (_jsxs("div", { className: 'sg-formItem', style: {
            // @ts-ignore
            '--SG_FORM_ITEM_CHAR_COUNT': characterCount,
        }, children: [label && (_jsxs("label", { className: 'sg-formItem--label', htmlFor: context.id, title: labelTooltipArray.join(' / '), onClick: help ? handleLabelClick : undefined, children: [isRequired && (_jsx("span", { className: 'sg-formItem--requireFlag', "aria-hidden": 'true', children: "*" })), _jsx("span", { className: 'sg-formItem--labelText', children: label }), help && (_jsx("span", { className: 'sg-formItem--helpFlag', "aria-hidden": 'true', children: "?" }))] })), _jsxs("div", { className: 'sg-formItem--body', children: [_jsx("div", { className: 'sg-formItem--content', children: _jsx(FormItemContext.Provider, { value: context, children: children }) }), showDescription && (_jsxs("p", { className: 'sg-formItem--desc', id: context.descriptionId, children: [errorMessage && _jsx("span", { className: 'sg-formItem--errorMessage', children: errorMessage }), hint && _jsx("span", { className: 'sg-formItem--hint', children: hint }), help && (_jsx("span", { className: classNames({
                                    'sg-formItem--help': true,
                                    'sg-formItem--help-isShown': showHelp,
                                }), children: help }))] }))] })] }));
};
//# sourceMappingURL=FormItem.js.map